// Global mixin so every component can gate a mutating button without
// repeating the same computed everywhere. Belt-and-suspenders UI polish
// only — the backend's requireWriteAccess/requireOwner middleware is the
// actual enforcement boundary; this just keeps a team member from seeing
// buttons that would 403 on click.
export default {
  computed: {
    // v-if="!isViewOnly" — gates ordinary create/edit/delete actions
    // (invoices, purchases, customers, etc.). FULL_ACCESS team members
    // pass this; VIEW_ONLY does not.
    isViewOnly() {
      return this.$store?.state?.auth?.user?.teamRole === "VIEW_ONLY";
    },

    // v-if="isOwner" — gates the stricter owner-only surfaces (Business
    // Profile, Bank Account, Terms & Conditions, Team Members). A
    // FULL_ACCESS team member does NOT pass this, unlike isViewOnly above.
    isOwner() {
      return !!this.$store?.state?.auth?.user && !this.$store.state.auth.user.ownerUserId;
    },
  },
};
